// Library
import React, { useState } from "react";

// Constant
import { getURL } from "../constants/APIConstant";

// Icons
import SendIcon from "@mui/icons-material/Send";
import RefreshIcon from "@mui/icons-material/Refresh";

// CSS
import { ChatInput, SendButton } from "./ChatApp";

export const convertStatsObjectToArray = (statsObject) => {
  return Object.entries(statsObject).map(([key, value]) => {
    const stat = key.split(":")[0].trim();
    const formattedValue = key.includes(":")
      ? key.split(":")[1].trim()
      : value.trim();

    return {
      stat,
      value: formattedValue,
    };
  });
};

const CurrentConvo = (props) => {
  const {
    setChat,
    setStats,
    setGifyOpen,
    setData,
    chats,
    setUserInput,
    setAllChatHistory = null,
    setPid = null,
    pid = null,
    isPolicyNavigator = null,
    setShowSpinner,
    notify,
    evrRefresh,
  } = props;
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const isEVR = isPolicyNavigator === null;

  const getStats = () => {
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    const URL = getURL("GPU_USAGE");
    fetch(URL, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        const dt = convertStatsObjectToArray(data);
        setStats(dt);
      })
      .catch((error) => {
        console.log("error: ", error);
        notify();
      });
  };

  const handleShowSteps = () => {
    setGifyOpen(true);
    setTimeout(() => {
      // setImgOpen(true);
    }, 1000);
  };

  const getPid = async () => {
    let resPid = chats.length === 0 ? null : pid;
    try {
      // if (chats.length === 0) {
      //   const requestOptions = {
      //     method: "POST",
      //     redirect: "follow",
      //   };
      //   const URL = getURL(
      //     isEVR
      //       ? "EVR_GET_PID"
      //       : isPolicyNavigator
      //       ? "FAA_GET_PID"
      //       : "HEALTH_CARE_GET_PID"
      //   );
      //   await fetch(URL, requestOptions)
      //     .then((response) => response.text())
      //     .then((result) => {
      //       resPid = result;
      //       setPid(result);
      //     })
      //     .catch((error) => {
      //       console.log("error: ", error);
      //       notify();
      //     });
      // }
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "topic": "Tortuosity of optic nerves"
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch("http://44.205.211.62:5503/generate_evidence_report", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          setShowSpinner(false)
          setData(
            JSON.parse(result));
          setPid(result)
        })
        .catch((error) => console.error("error",error));



    } catch (error) {
      console.log("error: ", error);
      notify();
      return null;
    } finally {
      return resPid;
    }
  };
  const fetchData = async (respid) => {
    let resdata = "";

    try {
      setLoading(true);
      const url = getURL(
        isPolicyNavigator ? "FAA_CHATBOT" : "HEALTH_CARE_CHATBOT"
      );
      const queryParams = new URLSearchParams({
        query: message,
        pid: respid,
        name: chats.length === 0 ? message : chats[0].question,
      });

      const fullUrl = `${url}?${queryParams.toString()}`;
      const response = await fetch(fullUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok || !response.body) {
        throw response.statusText;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          setLoading(false);
          break;
        }
        getStats();
        const decodedChunk = decoder.decode(value, { stream: true });
        // eslint-disable-next-line no-loop-func
        setData((prevValue) => {
          resdata = `${prevValue}${decodedChunk}`;
          return `${prevValue}${decodedChunk}`;
        });
      }
    } catch (error) {
      setLoading(false);
      console.log("error: ", error);
      notify();
      return resdata;
    } finally {
      return resdata;
    }
  };
  const onInputKeyDown = (e) => {
    console.log("e:",e, isEVR)
    if (e.key === "Enter" && !loading) {
      if (isEVR) {
        evrHandleSendMessage();
      } else {
        handleSendMessage();
      }
    }
  };
  const handleSendMessage = async () => {
    if (!loading && message !== "") {
      let resPid = null;
      setMessage("");
      setUserInput(message);
      setTimeout(() => handleShowSteps(), 2000);
      resPid = await getPid();
      const res = await fetchData(chats.length === 0 ? resPid : pid);
      setGifyOpen(false);
      // setImgOpen(false);
      setChat((prev) => [...prev, { question: message, response: res }]);
      if (chats.length === 0) {
        setAllChatHistory({ question: message, response: res, pid: resPid });
      }
      setMessage("");
      setUserInput("");
      setData("");
    }
  };
  const evrFetchData = async (resPid) => {
    if (resPid !== null) {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        topic: message,
        pid: resPid,
        // name: null,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const URL = getURL("EVR");
        fetch(URL, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            setChat((prev) => [
              ...prev,
              {
                question: JSON.parse(result).question,
                response: JSON.parse(result).response,
                references: JSON.parse(result).references,
                executed_at: JSON.parse(result).executed_at,
              },
            ]);
            if (chats.length === 0) {
              setAllChatHistory({
                question: JSON.parse(result).question,
                response: JSON.parse(result).response,
                references: JSON.parse(result).references,
                executed_at: JSON.parse(result).executed_at,
                pid: resPid,
              });
            }
            setMessage("");
            setUserInput("");
            setShowSpinner(false);
          })
          .catch((error) => {
            console.log("error", error);
            notify();
            setShowSpinner(false);
          });
      } catch (error) {
        console.log("error: ", error);
        setShowSpinner(false);
        notify();
      }
    } else {
      notify();
    }
  };
  const evrHandleSendMessage = async () => {
    if (!loading && message !== "") {
      let resPid = null;
      setMessage("");
      setUserInput(message);
      setShowSpinner(true);
      // setTimeout(() => handleShowSteps(), 2000);
      resPid = await getPid();
      evrFetchData(chats.length === 0 ? resPid : pid);
      // setGifyOpen(false);
      // setChat((prev) => [...prev, { question: message, response: res }]);
      // setMessage("");
      // setUserInput("");
      // setData("");
    }
  };

  return (
    <>
      <ChatInput className={`${isEVR ? "evr-user-input" : ""}`}>
        {isEVR && (
          <RefreshIcon
            className="custom-cursor-pointer"
            onClick={() => evrRefresh()}
          />
        )}
        <input
          className="user-input w-100 h-100"
          type="text"
          placeholder="Type your query..."
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          onKeyDown={onInputKeyDown}
        />
        <SendButton onClick={isEVR ? evrHandleSendMessage : handleSendMessage}>
          <SendIcon />
        </SendButton>
      </ChatInput>
    </>
  );
};

export default CurrentConvo;
